import {
  combineReducers,
  configureStore,
  PreloadedState,
} from '@reduxjs/toolkit';
import logger from 'redux-logger';

import { amplitudeContextReducer } from '@/features/amplitude/store/amplitude';
import { authenticationUpdateTokenReducer } from '@/features/authentication-update-token/store/authentication-update-token';
import { gameDataReducer } from '@/features/game/store/game-data';
import { gameContextReducer } from '@/features/game-context/store/game-context';
import { gameWindowHelperDataReducer } from '@/features/game-window-integration/store/game-window-helper-data';
import { geolocationReducer } from '@/features/geolocation/store/geolocation';
import { geolocationUpdateTokenReducer } from '@/features/geolocation-update-token/store/geolocation-update-token';

const rootReducer = combineReducers({
  gameContext: gameContextReducer,
  geolocation: geolocationReducer,
  gameData: gameDataReducer,
  gameWindowHelperData: gameWindowHelperDataReducer,
  gelocationUpdateToken: geolocationUpdateTokenReducer,
  authenticationUpdateToken: authenticationUpdateTokenReducer,
  amplitudeExperiments: amplitudeContextReducer,
});

const loggerMiddleware = process.env.NODE_CONFIG_ENV !== 'prod' ? [logger] : [];

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefault) => getDefault().concat(loggerMiddleware),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
